import { render } from "./RequestOtp.vue?vue&type=template&id=570924a0"
import script from "./RequestOtp.vue?vue&type=script&lang=js"
export * from "./RequestOtp.vue?vue&type=script&lang=js"

import "./RequestOtp.vue?vue&type=style&index=0&id=570924a0&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__